export const BaseFillSubmit = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.907 2.65777L1.24725 10.3651C0.361602 10.7309 0.447842 12.0125 1.37451 12.2564L6.20732 13.5282L14.3192 8.12027C14.5202 7.98627 14.7424 8.25729 14.5716 8.4281L8.59437 14.4053L17.652 20.5809C18.2688 21.0015 19.1123 20.6224 19.2072 19.8819L21.2806 3.7092C21.3783 2.94758 20.6167 2.36464 19.907 2.65777Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M8 15.0002V19.159C8 19.8027 8.79556 20.1051 9.22319 19.6241L12 16.5002L8.61538 14.3848L8 15.0002Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
